<template>
  <b-row>
    <b-col cols="12">
      <form-pixel />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import FormPixel from './FormPixel.vue'

export default {
  components: {
    BRow,
    BCol,
    FormPixel,
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
